import AnalyticsVersions from "./AnalyticsVersions";
import { resolveAnalyticsGlobalByVersion } from "./Utils";
/**
 * DTM client for Adobe Analytics
 */
var AdobeAnalyticsDtmClient = /** @class */ (function () {
    function AdobeAnalyticsDtmClient(config) {
        this.reportSuite = config.reportSuite;
        this.mapping = config.mapping;
        var dtm = resolveAnalyticsGlobalByVersion(AnalyticsVersions.DynamicTagManagement);
        if (!dtm) {
            throw new Error("DTM not loaded");
        }
        this.trackingObject = dtm(this.reportSuite);
        this.props = {};
    }
    AdobeAnalyticsDtmClient.prototype.sendEvent = function (event, evars, props) {
        var _this = this;
        var request = JSON.parse(JSON.stringify(this.props));
        var eventIndex = this.getIndexByEvent(event);
        Object.keys(evars).forEach(function (evar) {
            var eVarIndex = _this.getIndexByEVar(evar);
            if (eVarIndex === null) {
                throw new Error("No index for eVar \"" + evar + "\" configured in mapping");
            }
            request["eVar" + eVarIndex] = evars[evar];
        });
        Object.keys(props || {}).forEach(function (prop) {
            var propIndex = _this.getIndexByProp(prop);
            if (propIndex === null) {
                throw new Error("No index for prop \"" + prop + "\" configured in mapping");
            }
            request["prop" + propIndex] = props[prop];
        });
        if (eventIndex === null) {
            throw new Error("No index for event \"" + event + "\" configured in mapping");
        }
        request.events = "event" + eventIndex;
        this.sendTrackingRequest(request);
    };
    AdobeAnalyticsDtmClient.prototype.sendSetProps = function () {
        this.sendTrackingRequest(this.props);
    };
    /**
     * set
     * Add a persistent property to the event request. When the next event is fired all the properties will be attached.
     */
    AdobeAnalyticsDtmClient.prototype.set = function (prop) {
        var index = this.getIndexByProp(prop);
        if (index === null) {
            throw new Error("No index for prop \"" + prop + "\" configured in mapping");
        }
        this.props["prop" + index] = prop;
    };
    AdobeAnalyticsDtmClient.prototype.sendTrackingRequest = function (request) {
        var requestKeys = Object.keys(request);
        var trackingObject = this.trackingObject;
        requestKeys.forEach(function (key) {
            trackingObject[key] = request[key];
        });
        trackingObject.tl(true);
    };
    AdobeAnalyticsDtmClient.prototype.getIndexByProp = function (prop) {
        var propsMapping = this.mapping.props;
        return propsMapping && prop in propsMapping ? propsMapping[prop] : null;
    };
    AdobeAnalyticsDtmClient.prototype.getIndexByEVar = function (evar) {
        var evarsMapping = this.mapping.evars;
        return evarsMapping && evar in evarsMapping ? evarsMapping[evar] : null;
    };
    AdobeAnalyticsDtmClient.prototype.getIndexByEvent = function (event) {
        var eventsMapping = this.mapping.events;
        return eventsMapping && event in eventsMapping ? eventsMapping[event] : null;
    };
    return AdobeAnalyticsDtmClient;
}());
export default AdobeAnalyticsDtmClient;
//# sourceMappingURL=AdobeAnalyticsDtmClient.js.map